import { Modal, ModalContentProps } from '@mantine/core';
import clsx from 'clsx';
import { forwardRef } from 'react';

export type ModalFormContentProps = ModalContentProps;

export const createModalFormContent = () => {
	const ModalFormContent = forwardRef<HTMLDivElement, ModalFormContentProps>(
		({ className, classNames, children, ...props }, ref) => (
			<Modal.Content
				ref={ref}
				className={clsx('modal-form-content', className)}
				classNames={{
					...classNames,
					inner: clsx('modal-form-inner', classNames?.inner),
				}}
				{...props}
			>
				{children}
			</Modal.Content>
		),
	);

	return ModalFormContent;
};
